<template>
  <pu-modal
    modal-class="booking-message-modal"
    :show-trigger="showTrigger"
    :use-portal="true"
    :show-modal="showModal"
    modal-hash="booking-message"
  >
    <template #header>
      <slot name="header" />
    </template>

    <header>
      <img src="@/assets/images/pitchup-favicon.svg?data" />
    </header>

    <div class="booking-message">
      <h3 v-thtml="message" />
      <translate tag="a" class="button primary" :href="bookAgainUrl">
        Search again
      </translate>
    </div>
  </pu-modal>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class BookingMessageModal extends Vue {
  @Prop({ default: false })
  showModal: boolean

  @Prop()
  message: string

  @Prop({ required: true })
  bookAgainUrl: string

  @Prop({ default: false })
  showTrigger: boolean
}

export default toNative(BookingMessageModal)
</script>
<style>
.booking-message-modal.modal-container {
  height: calc(100% - 6vw);
}
.booking-message-modal .modal-body {
  display: flex;
  flex-direction: column;
}
</style>
<style scoped>
header {
  padding: 1em 0 0 1.4em;
}

header img {
  height: 2em;
  width: auto;
}

p {
  font-size: var(--body);
}

h3 {
  line-height: 1.3;
}

.button {
  margin-top: 2em;
}

.booking-message {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  padding: 0 1.4em;
  text-align: center;
}
</style>
